import { useUserContext } from "@dexteel/mesf-core";
import { useEffect } from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { AssetDetails } from "./AssetDetails";
import {
	AssetDetailsProvider,
	useAssetDetailsContext,
} from "./context/assetDetailsContext";

type Props = {};

const AssetDetailsPage = (props: Props) => {
	const { AssetIdParam } = useParams();

	const {
		state: { defaultAreaId },
	} = useUserContext();
	const [searchParams, setSearchParams] = useSearchParams();
	const {
		actions: { setCurrentGridName },
	} = useAssetDetailsContext();

	useEffect(() => {
		if (!searchParams.has("resource")) {
			searchParams.set("resource", "drawings");
			setCurrentGridName("drawings");
			setSearchParams(searchParams, { replace: true });
		}
	}, []);

	if (AssetIdParam) {
		return (
			<AssetDetailsProvider>
				<AssetDetails />
			</AssetDetailsProvider>
		);
	} else {
		return <Navigate to={`/asset-details/${defaultAreaId}`} replace={true} />;
	}
};

export default AssetDetailsPage;
